import { SERVICE_TYPE_ID } from '../../booking/models/service-type';

const getServiceTypeKey = (id) => {
    switch (id) {
        case SERVICE_TYPE_ID.COLLECTIVE:
            return 'collective';
        case SERVICE_TYPE_ID.INDIVIDUAL:
            return 'individual';
        case SERVICE_TYPE_ID.EXCLUSIVE:
            return 'exclusive';
        case SERVICE_TYPE_ID.UPON_REQUEST:
            return 'uponRequest';
        case SERVICE_TYPE_ID.SHARED_INDIVIDUAL:
            return 'sharedIndividual';
        default:
            return console.error('Invalid service type id');
    }
};

export { getServiceTypeKey };
